import React from "react";

export const CloseIcon = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.1252 17.0812L17.1357 15.0693L6.878 4.80485L4.86747 6.8167L15.1252 17.0812Z"
      fill="white"
    />
    <path
      d="M6.878 17.0838L17.1357 6.81934L15.1252 4.80749L4.86747 15.072L6.878 17.0838Z"
      fill="white"
    />
  </svg>
);

export const AddMoreIcon = () => (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5 3C13.5 2.44772 13.0523 2 12.5 2H11.5C10.9477 2 10.5 2.44772 10.5 3V10.5H3C2.44772 10.5 2 10.9477 2 11.5V12.5C2 13.0523 2.44772 13.5 3 13.5H10.5V21C10.5 21.5523 10.9477 22 11.5 22H12.5C13.0523 22 13.5 21.5523 13.5 21V13.5H21C21.5523 13.5 22 13.0523 22 12.5V11.5C22 10.9477 21.5523 10.5 21 10.5H13.5V3Z"
      fill="#000000"
    />
  </svg>
);
export const CollapseIcon = ({
  width = 24,
  height = 24,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.59961 6.00078C3.59961 5.68252 3.72604 5.3773 3.95108 5.15225C4.17612 4.92721 4.48135 4.80078 4.79961 4.80078H19.1996C19.5179 4.80078 19.8231 4.92721 20.0481 5.15225C20.2732 5.3773 20.3996 5.68252 20.3996 6.00078C20.3996 6.31904 20.2732 6.62427 20.0481 6.84931C19.8231 7.07435 19.5179 7.20078 19.1996 7.20078H4.79961C4.48135 7.20078 4.17612 7.07435 3.95108 6.84931C3.72604 6.62427 3.59961 6.31904 3.59961 6.00078ZM3.59961 12.0008C3.59961 11.6825 3.72604 11.3773 3.95108 11.1523C4.17612 10.9272 4.48135 10.8008 4.79961 10.8008H11.9996C12.3179 10.8008 12.6231 10.9272 12.8481 11.1523C13.0732 11.3773 13.1996 11.6825 13.1996 12.0008C13.1996 12.319 13.0732 12.6243 12.8481 12.8493C12.6231 13.0744 12.3179 13.2008 11.9996 13.2008H4.79961C4.48135 13.2008 4.17612 13.0744 3.95108 12.8493C3.72604 12.6243 3.59961 12.319 3.59961 12.0008ZM3.59961 18.0008C3.59961 17.6825 3.72604 17.3773 3.95108 17.1523C4.17612 16.9272 4.48135 16.8008 4.79961 16.8008H19.1996C19.5179 16.8008 19.8231 16.9272 20.0481 17.1523C20.2732 17.3773 20.3996 17.6825 20.3996 18.0008C20.3996 18.319 20.2732 18.6243 20.0481 18.8493C19.8231 19.0744 19.5179 19.2008 19.1996 19.2008H4.79961C4.48135 19.2008 4.17612 19.0744 3.95108 18.8493C3.72604 18.6243 3.59961 18.319 3.59961 18.0008Z"
      fill={color}
    />
  </svg>
);

export const CallIcon = ({
  width = 20,
  height = 20,
  color = "#3E50F7",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M18.3077 15.2743C18.3077 15.5743 18.241 15.8827 18.0993 16.1827C17.9577 16.4827 17.7744 16.766 17.5327 17.0327C17.1244 17.4827 16.6743 17.8077 16.166 18.016C15.666 18.2244 15.1244 18.3327 14.541 18.3327C13.691 18.3327 12.7827 18.1327 11.8243 17.7244C10.866 17.316 9.90768 16.766 8.95768 16.0744C7.99935 15.3744 7.09102 14.5993 6.22435 13.741C5.36602 12.8743 4.59102 11.966 3.89935 11.016C3.21602 10.066 2.66602 9.11602 2.26602 8.17435C1.86602 7.22435 1.66602 6.31602 1.66602 5.44935C1.66602 4.88268 1.76602 4.34102 1.96602 3.84102C2.16602 3.33268 2.48268 2.86602 2.92435 2.44935C3.45768 1.92435 4.04102 1.66602 4.65768 1.66602C4.89102 1.66602 5.12435 1.71602 5.33268 1.81602C5.54935 1.91602 5.74102 2.06602 5.89102 2.28268L7.82435 5.00768C7.97435 5.21602 8.08268 5.40768 8.15768 5.59102C8.23268 5.76602 8.27435 5.94102 8.27435 6.09935C8.27435 6.29935 8.21602 6.49935 8.09935 6.69102C7.99102 6.88268 7.83268 7.08268 7.63268 7.28268L6.99935 7.94102C6.90768 8.03268 6.86602 8.14102 6.86602 8.27435C6.86602 8.34102 6.87435 8.39935 6.89102 8.46602C6.91602 8.53268 6.94102 8.58268 6.95768 8.63268C7.10768 8.90768 7.36602 9.26602 7.73268 9.69935C8.10768 10.1327 8.50768 10.5743 8.94102 11.016C9.39102 11.4577 9.82435 11.866 10.266 12.241C10.6993 12.6077 11.0577 12.8577 11.341 13.0077C11.3827 13.0243 11.4327 13.0493 11.491 13.0743C11.5577 13.0993 11.6243 13.1077 11.6993 13.1077C11.841 13.1077 11.9493 13.0577 12.041 12.966L12.6743 12.341C12.8827 12.1327 13.0827 11.9743 13.2743 11.8743C13.466 11.7577 13.6577 11.6993 13.866 11.6993C14.0243 11.6993 14.191 11.7327 14.3743 11.8077C14.5577 11.8827 14.7494 11.991 14.9577 12.1327L17.716 14.091C17.9327 14.241 18.0827 14.416 18.1743 14.6243C18.2577 14.8327 18.3077 15.041 18.3077 15.2743Z"
      stroke={color}
      strokeWidth="1.5"
      strokeMiterlimit="10"
    />
    <path
      d="M15.4167 7.4987C15.4167 6.9987 15.025 6.23203 14.4417 5.60703C13.9083 5.03203 13.2 4.58203 12.5 4.58203"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3333 7.49935C18.3333 4.27435 15.725 1.66602 12.5 1.66602"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AddIcon = ({
  width = 20,
  height = 20,
  color = "#3E50F7",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path d="M10 10H5H10Z" fill={color} />
    <path
      d="M10 5V10M10 10V15M10 10H15M10 10H5"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const NotificationIcon = ({
  width = 20,
  height = 20,
  color = "#EA8E32",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99935 14.8724C14.6987 14.8724 16.8727 14.2695 17.0827 11.8498C17.0827 9.43168 15.567 9.58717 15.567 6.62027C15.567 4.3028 13.3704 1.66602 9.99935 1.66602C6.62833 1.66602 4.43172 4.3028 4.43172 6.62027C4.43172 9.58717 2.91602 9.43168 2.91602 11.8498C3.12681 14.2787 5.30083 14.8724 9.99935 14.8724Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.4"
      d="M11.9894 17.3809C10.8526 18.6431 9.07929 18.6581 7.93164 17.3809"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DollarIcon = ({
  width = 20,
  height = 20,
  color = "#03B656",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M7.22656 11.9422C7.22656 13.0172 8.05156 13.8839 9.07656 13.8839H11.1682C12.0599 13.8839 12.7849 13.1255 12.7849 12.1922C12.7849 11.1755 12.3432 10.8172 11.6849 10.5839L8.32656 9.41719C7.66823 9.18385 7.22656 8.82552 7.22656 7.80885C7.22656 6.87552 7.95156 6.11719 8.84323 6.11719H10.9349C11.9599 6.11719 12.7849 6.98385 12.7849 8.05885"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 5V15"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.99935 18.3327C14.6017 18.3327 18.3327 14.6017 18.3327 9.99935C18.3327 5.39698 14.6017 1.66602 9.99935 1.66602C5.39698 1.66602 1.66602 5.39698 1.66602 9.99935C1.66602 14.6017 5.39698 18.3327 9.99935 18.3327Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const DashboardIcon = ({
  width = 20,
  height = 20,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M8.99931 22L8.74868 18.4911C8.61393 16.6046 10.108 15 11.9993 15C13.8906 15 15.3847 16.6046 15.2499 18.4911L14.9993 22"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M2.35139 13.2135C1.99837 10.9162 1.82186 9.76763 2.25617 8.74938C2.69047 7.73112 3.65403 7.03443 5.58114 5.64106L7.02099 4.6C9.41829 2.86667 10.6169 2 12 2C13.383 2 14.5817 2.86667 16.979 4.6L18.4188 5.64106C20.346 7.03443 21.3095 7.73112 21.7438 8.74938C22.1781 9.76763 22.0016 10.9162 21.6486 13.2135L21.3476 15.1724C20.8471 18.4289 20.5969 20.0572 19.429 21.0286C18.2611 22 16.5536 22 13.1388 22H10.8612C7.44634 22 5.73891 22 4.571 21.0286C3.40309 20.0572 3.15287 18.4289 2.65243 15.1724L2.35139 13.2135Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
export const MessageIcon = ({
  width = 20,
  height = 20,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M14.1706 20.3905C18.3536 20.1125 21.6856 16.7332 21.9598 12.4909C22.0134 11.6607 22.0134 10.8009 21.9598 9.9707C21.6856 5.72838 18.3536 2.34913 14.1706 2.07107C12.7435 1.97621 11.2536 1.97641 9.8294 2.07107C5.64639 2.34913 2.31441 5.72838 2.04024 9.9707C1.98659 10.8009 1.98659 11.6607 2.04024 12.4909C2.1401 14.036 2.82343 15.4666 3.62791 16.6746C4.09501 17.5203 3.78674 18.5758 3.30021 19.4978C2.94941 20.1626 2.77401 20.495 2.91484 20.7351C3.05568 20.9752 3.37026 20.9829 3.99943 20.9982C5.24367 21.0285 6.08268 20.6757 6.74868 20.1846C7.1264 19.9061 7.31527 19.7668 7.44544 19.7508C7.5756 19.7348 7.83177 19.8403 8.34401 20.0513C8.8044 20.2409 9.33896 20.3579 9.8294 20.3905C11.2536 20.4852 12.7435 20.4854 14.1706 20.3905Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 14H15.5M8.5 9H12"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const CashAmountIcon = ({
  width = 20,
  height = 20,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M12 6.5V8M12 8C10.4812 8 9.25 8.92865 9.25 10.0741C9.25 11.2196 10 11.8519 12 11.8519C14 11.8519 15 12.4445 15 13.926C15 15.4075 13.6569 16 12 16M12 8C13.5188 8 14.75 8.92865 14.75 10.0741M12 16V17.5M12 16C10.3431 16 9 15.0715 9 13.926"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export const AppointmentsIcon = ({
  width = 20,
  height = 20,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M18 2V4M6 2V4"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9955 13H12.0045M11.9955 17H12.0045M15.991 13H16M8 13H8.00897M8 17H8.00897"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.5 8H20.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 12.2432C2.5 7.88594 2.5 5.70728 3.75212 4.35364C5.00424 3 7.01949 3 11.05 3H12.95C16.9805 3 18.9958 3 20.2479 4.35364C21.5 5.70728 21.5 7.88594 21.5 12.2432V12.7568C21.5 17.1141 21.5 19.2927 20.2479 20.6464C18.9958 22 16.9805 22 12.95 22H11.05C7.01949 22 5.00424 22 3.75212 20.6464C2.5 19.2927 2.5 17.1141 2.5 12.7568V12.2432Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3 8H21"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const TeamMemberIcon = ({
  width = 20,
  height = 20,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M15 11C17.2091 11 19 9.20914 19 7C19 4.79086 17.2091 3 15 3"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 14H7C4.23858 14 2 16.2386 2 19C2 20.1046 2.89543 21 4 21H14C15.1046 21 16 20.1046 16 19C16 16.2386 13.7614 14 11 14Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M17 14C19.7614 14 22 16.2386 22 19C22 20.1046 21.1046 21 20 21H18.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PromotionsIcon = ({
  width = 20,
  height = 20,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M7.5 12.5V6.5"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.95235 13.0229L9.70643 16.5215C9.86565 16.8391 10.1066 17.1085 10.4045 17.3021L12.9112 18.9311C12.9648 18.9659 12.9725 19.0413 12.9272 19.0863L10.0226 21.9717C9.98104 22.013 9.91308 22.0099 9.87543 21.965L7.44177 19.0602C7.14013 18.7002 6.97482 18.2455 6.97482 17.7758V13.0229M7.50729 6.49753H5C3.89543 6.49753 3 7.39297 3 8.49754V10.4858C3 11.5904 3.89543 12.4858 5 12.4858H7.50729L16.7191 16.4661C17.48 16.7949 18.3803 16.6319 18.8959 15.9829C20.2945 14.2224 21 12.241 21 8.98196C20.799 6.4748 20.1333 4.59941 18.9102 3.01422C18.411 2.36723 17.5228 2.21151 16.7716 2.53301L7.50729 6.49753Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const DataInsidesIcon = ({
  width = 20,
  height = 20,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M11.024 22C15.3242 22 18.9218 18.9922 19.8279 14.9657C20.0135 14.141 20.1063 13.7286 19.8052 13.3523C19.5042 12.976 19.017 12.976 18.0427 12.976H11.024M11.024 22C6.04018 22 2 17.9598 2 12.976C2 8.67584 5.00779 5.07818 9.03431 4.17208C9.85901 3.9865 10.2714 3.89371 10.6477 4.19475C11.024 4.4958 11.024 4.98298 11.024 5.95734V12.976M11.024 22V12.976"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M21.5541 7.02647C20.7305 4.93588 19.0641 3.26953 16.9735 2.44595C15.8783 2.01448 15.3307 1.79874 14.6653 2.25173C14 2.70472 14 3.44563 14 4.92747V6.95648C14 8.39121 14 9.10857 14.4457 9.55429C14.8914 10 15.6088 10 17.0435 10H19.0725C20.5544 10 21.2953 10 21.7483 9.33467C22.2013 8.66935 21.9855 8.12172 21.5541 7.02647Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const SettingsIcon = ({
  width = 20,
  height = 20,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <path
      d="M21.3175 7.14139L20.8239 6.28479C20.4506 5.63696 20.264 5.31305 19.9464 5.18388C19.6288 5.05472 19.2696 5.15664 18.5513 5.36048L17.3311 5.70418C16.8725 5.80994 16.3913 5.74994 15.9726 5.53479L15.6357 5.34042C15.2766 5.11043 15.0004 4.77133 14.8475 4.37274L14.5136 3.37536C14.294 2.71534 14.1842 2.38533 13.9228 2.19657C13.6615 2.00781 13.3143 2.00781 12.6199 2.00781H11.5051C10.8108 2.00781 10.4636 2.00781 10.2022 2.19657C9.94085 2.38533 9.83106 2.71534 9.61149 3.37536L9.27753 4.37274C9.12465 4.77133 8.84845 5.11043 8.48937 5.34042L8.15249 5.53479C7.73374 5.74994 7.25259 5.80994 6.79398 5.70418L5.57375 5.36048C4.85541 5.15664 4.49625 5.05472 4.17867 5.18388C3.86109 5.31305 3.67445 5.63696 3.30115 6.28479L2.80757 7.14139C2.45766 7.74864 2.2827 8.05227 2.31666 8.37549C2.35061 8.69871 2.58483 8.95918 3.05326 9.48012L4.0843 10.6328C4.3363 10.9518 4.51521 11.5078 4.51521 12.0077C4.51521 12.5078 4.33636 13.0636 4.08433 13.3827L3.05326 14.5354C2.58483 15.0564 2.35062 15.3168 2.31666 15.6401C2.2827 15.9633 2.45766 16.2669 2.80757 16.8741L3.30114 17.7307C3.67443 18.3785 3.86109 18.7025 4.17867 18.8316C4.49625 18.9608 4.85542 18.8589 5.57377 18.655L6.79394 18.3113C7.25263 18.2055 7.73387 18.2656 8.15267 18.4808L8.4895 18.6752C8.84851 18.9052 9.12464 19.2442 9.2775 19.6428L9.61149 20.6403C9.83106 21.3003 9.94085 21.6303 10.2022 21.8191C10.4636 22.0078 10.8108 22.0078 11.5051 22.0078H12.6199C13.3143 22.0078 13.6615 22.0078 13.9228 21.8191C14.1842 21.6303 14.294 21.3003 14.5136 20.6403L14.8476 19.6428C15.0004 19.2442 15.2765 18.9052 15.6356 18.6752L15.9724 18.4808C16.3912 18.2656 16.8724 18.2055 17.3311 18.3113L18.5513 18.655C19.2696 18.8589 19.6288 18.9608 19.9464 18.8316C20.264 18.7025 20.4506 18.3785 20.8239 17.7307L21.3175 16.8741C21.6674 16.2669 21.8423 15.9633 21.8084 15.6401C21.7744 15.3168 21.5402 15.0564 21.0718 14.5354L20.0407 13.3827C19.7887 13.0636 19.6098 12.5078 19.6098 12.0077C19.6098 11.5078 19.7888 10.9518 20.0407 10.6328L21.0718 9.48012C21.5402 8.95918 21.7744 8.69871 21.8084 8.37549C21.8423 8.05227 21.6674 7.74864 21.3175 7.14139Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M15.5195 12C15.5195 13.933 13.9525 15.5 12.0195 15.5C10.0865 15.5 8.51953 13.933 8.51953 12C8.51953 10.067 10.0865 8.5 12.0195 8.5C13.9525 8.5 15.5195 10.067 15.5195 12Z"
      stroke={color}
      strokeWidth="1.5"
    />
  </svg>
);

export const PowerDialer = ({
  width = 18,
  height = 18,
  color = "#7E869A",
  className,
  ...rest
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...rest}
    >
      <path
        d="M18.3077 15.2743C18.3077 15.5743 18.241 15.8827 18.0993 16.1827C17.9577 16.4827 17.7744 16.766 17.5327 17.0327C17.1244 17.4827 16.6743 17.8077 16.166 18.016C15.666 18.2244 15.1244 18.3327 14.541 18.3327C13.691 18.3327 12.7827 18.1327 11.8243 17.7244C10.866 17.316 9.90768 16.766 8.95768 16.0744C7.99935 15.3744 7.09102 14.5993 6.22435 13.741C5.36602 12.8743 4.59102 11.966 3.89935 11.016C3.21602 10.066 2.66602 9.11602 2.26602 8.17435C1.86602 7.22435 1.66602 6.31602 1.66602 5.44935C1.66602 4.88268 1.76602 4.34102 1.96602 3.84102C2.16602 3.33268 2.48268 2.86602 2.92435 2.44935C3.45768 1.92435 4.04102 1.66602 4.65768 1.66602C4.89102 1.66602 5.12435 1.71602 5.33268 1.81602C5.54935 1.91602 5.74102 2.06602 5.89102 2.28268L7.82435 5.00768C7.97435 5.21602 8.08268 5.40768 8.15768 5.59102C8.23268 5.76602 8.27435 5.94102 8.27435 6.09935C8.27435 6.29935 8.21602 6.49935 8.09935 6.69102C7.99102 6.88268 7.83268 7.08268 7.63268 7.28268L6.99935 7.94102C6.90768 8.03268 6.86602 8.14102 6.86602 8.27435C6.86602 8.34102 6.87435 8.39935 6.89102 8.46602C6.91602 8.53268 6.94102 8.58268 6.95768 8.63268C7.10768 8.90768 7.36602 9.26602 7.73268 9.69935C8.10768 10.1327 8.50768 10.5743 8.94102 11.016C9.39102 11.4577 9.82435 11.866 10.266 12.241C10.6993 12.6077 11.0577 12.8577 11.341 13.0077C11.3827 13.0243 11.4327 13.0493 11.491 13.0743C11.5577 13.0993 11.6243 13.1077 11.6993 13.1077C11.841 13.1077 11.9493 13.0577 12.041 12.966L12.6743 12.341C12.8827 12.1327 13.0827 11.9743 13.2743 11.8743C13.466 11.7577 13.6577 11.6993 13.866 11.6993C14.0243 11.6993 14.191 11.7327 14.3743 11.8077C14.5577 11.8827 14.7494 11.991 14.9577 12.1327L17.716 14.091C17.9327 14.241 18.0827 14.416 18.1743 14.6243C18.2577 14.8327 18.3077 15.041 18.3077 15.2743Z"
        stroke={color}
        strokeWidth="1.5"
        strokeMiterlimit="10"
      />
      <path
        d="M15.4167 7.4987C15.4167 6.9987 15.025 6.23203 14.4417 5.60703C13.9083 5.03203 13.2 4.58203 12.5 4.58203"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3333 7.49935C18.3333 4.27435 15.725 1.66602 12.5 1.66602"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const searchIcon = (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="#9ea0a8"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.0252 14.3469L18.5943 17.9152L17.4152 19.0943L13.8469 15.5252C12.5191 16.5895 10.8677 17.1684 9.16602 17.166C5.02602 17.166 1.66602 13.806 1.66602 9.66602C1.66602 5.52602 5.02602 2.16602 9.16602 2.16602C13.306 2.16602 16.666 5.52602 16.666 9.66602C16.6684 11.3677 16.0895 13.0191 15.0252 14.3469ZM13.3535 13.7285C14.4111 12.6409 15.0017 11.183 14.9993 9.66602C14.9993 6.44268 12.3885 3.83268 9.16602 3.83268C5.94268 3.83268 3.33268 6.44268 3.33268 9.66602C3.33268 12.8885 5.94268 15.4993 9.16602 15.4993C10.683 15.5017 12.1409 14.9111 13.2285 13.8535L13.3535 13.7285Z"
      fill={0.4}
      fillOpacity="#0D1126"
    />
  </svg>
);
export const slashIcon = (
  <svg
    width="18"
    height="21"
    viewBox="0 0 18 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 6.5C0 3.18629 2.68629 0.5 6 0.5H12C15.3137 0.5 18 3.18629 18 6.5V14.5C18 17.8137 15.3137 20.5 12 20.5H6C2.68629 20.5 0 17.8137 0 14.5V6.5Z"
      fill="#E9EAEC"
    />
    <path
      d="M11.3068 4.84091L8.02557 17.0312H6.69815L9.9794 4.84091H11.3068Z"
      fill="#BABDC5"
    />
  </svg>
);

export const FunnelAndForms = ({
  width = 20,
  height = 19,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    strokeWidth="1.5"
    stroke={color}
    class="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 0 1-.659 1.591l-5.432 5.432a2.25 2.25 0 0 0-.659 1.591v2.927a2.25 2.25 0 0 1-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 0 0-.659-1.591L3.659 7.409A2.25 2.25 0 0 1 3 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0 1 12 3Z"
    />
  </svg>
);

export const FindLeadsIcon = ({
  width = 20,
  height = 19,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height={height}
    width={width}
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke={color}
    className="size-6"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 6.75V15m6-6v8.25m.503 3.498 4.875-2.437c.381-.19.622-.58.622-1.006V4.82c0-.836-.88-1.38-1.628-1.006l-3.869 1.934c-.317.159-.69.159-1.006 0L9.503 3.252a1.125 1.125 0 0 0-1.006 0L3.622 5.689C3.24 5.88 3 6.27 3 6.695V19.18c0 .836.88 1.38 1.628 1.006l3.869-1.934c.317-.159.69-.159 1.006 0l4.994 2.497c.317.158.69.158 1.006 0Z"
    />
  </svg>
);

export const GetStarted = ({
  width = 20,
  height = 19,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    fill={color}
    height={height}
    width={width}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...rest}
  >
    <g>
      <g>
        <rect width="48" height="48" fill="none" />
      </g>
      <g>
        <path d="M9.7,40a2,2,0,0,1-1.4-.6A21.6,21.6,0,0,1,2,24a22,22,0,0,1,44,0,21.6,21.6,0,0,1-6.3,15.4,2,2,0,1,1-2.8-2.8,18,18,0,1,0-25.8,0,1.9,1.9,0,0,1,0,2.8A2,2,0,0,1,9.7,40Z" />
        <path d="M22.6,14.6l-8,7.9a2.1,2.1,0,0,0-.2,2.7,1.9,1.9,0,0,0,3,.2L22,20.8V44a2,2,0,0,0,2,2h0a2,2,0,0,0,2-2V20.8l4.6,4.6a1.9,1.9,0,0,0,3-.2,2.1,2.1,0,0,0-.2-2.7l-8-7.9A1.9,1.9,0,0,0,22.6,14.6Z" />
      </g>
    </g>
  </svg>
);

export const EnhanceData = ({
  width = 20,
  height = 19,
  color = "#7E869A",
  className,
  ...rest
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={1.5}
    stroke={color}
    height={height}
    width={width}
    className={className}
    {...rest}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
    />
  </svg>
);

export const SideNavLeftIcon = ({
  height = 20,
  width = 20,
  color = "#475467",
  style = {}
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.61366 6.13633C9.90656 6.42922 9.90656 6.90409 9.61366 7.19699L6.81066 9.99999L9.61366 12.803C9.90656 13.0959 9.90656 13.5708 9.61366 13.8637C9.32077 14.1565 8.8459 14.1565 8.553 13.8637L5.21967 10.5303C4.92678 10.2374 4.92678 9.76255 5.21967 9.46966L8.553 6.13633C8.8459 5.84343 9.32077 5.84343 9.61366 6.13633Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.0303 6.13633C15.3232 6.42922 15.3232 6.90409 15.0303 7.19699L12.2273 9.99999L15.0303 12.803C15.3232 13.0959 15.3232 13.5708 15.0303 13.8637C14.7374 14.1565 14.2626 14.1565 13.9697 13.8637L10.6363 10.5303C10.3434 10.2374 10.3434 9.76255 10.6363 9.46966L13.9697 6.13633C14.2626 5.84343 14.7374 5.84343 15.0303 6.13633Z"
        fill={color}
      />
    </svg>
  );
};

export const InsuranceIcon = ({
  height = 23,
  width = 23,
  color = "#475467",
  style = {},
  ...rest
}) => {
  return (
    <svg
      strokeWidth="3"
      stroke={color}
      fill="none"
      width={width}
      height={height}
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      style={style}
      {...rest}
    >
      <path d="M52.35,57.08H11.65v-50A.11.11,0,0,1,11.81,7l4.11,3.85a.11.11,0,0,0,.13,0L19.35,7a.09.09,0,0,1,.12,0l3.72,3.89a.11.11,0,0,0,.13,0L26.61,7a.09.09,0,0,1,.13,0l2.86,3.87a.1.1,0,0,0,.14,0L33,7a.09.09,0,0,1,.13,0l2.69,3.85a.1.1,0,0,0,.14,0L38.86,7A.1.1,0,0,1,39,7l2.85,3.85a.1.1,0,0,0,.14,0L44.7,7a.09.09,0,0,1,.15,0l2.25,3.84a.09.09,0,0,0,.13,0L52.2,7a.1.1,0,0,1,.15.09Z" strokeLinecap="round" />
      <line x1="19.42" y1="43.04" x2="46.02" y2="43.04" strokeLinecap="round" />
      <line x1="19.42" y1="49.29" x2="46.02" y2="49.29" strokeLinecap="round" />
      <path d="M37.87,21.74a5.62,5.62,0,0,0-5.28-3.4c-4.76,0-4.94,3.4-4.94,3.4s-.72,4.2,5.11,4.65c6.06.47,5.11,4.65,5.11,4.65s-.62,3.64-5.11,3.87-5.89-4.49-5.89-4.49" />
      <line x1="32.59" y1="15.31" x2="32.59" y2="38.4" />
    </svg>
  );
};
export const TasksIcon = ({
  height = 23,
  width = 23,
  color =  '#475476',
  style = {},
  ...rest
}) => {
  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={color}
          style={style}
          {...rest}
      >
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0ZM3.75 12h.007v.008H3.75V12Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm-.375 5.25h.007v.008H3.75v-.008Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z"/>
      </svg>
  )
};

export const FeatureRequestIcon = ({
  height = 23,
  width = 23,
  color =  '#475476',
  style = {},
  ...rest
}) => {
  return (
      <svg
          xmlns="http://www.w3.org/2000/svg"
          width={width}
          height={height}
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth="1.5"
          stroke={color}
          style={style}
          {...rest}
      >
         <path strokeLinecap="round" strokeLinejoin="round" d="M12 18v-5.25m0 0a6.01 6.01 0 0 0 1.5-.189m-1.5.189a6.01 6.01 0 0 1-1.5-.189m3.75 7.478a12.06 12.06 0 0 1-4.5 0m3.75 2.383a14.406 14.406 0 0 1-3 0M14.25 18v-.192c0-.983.658-1.823 1.508-2.316a7.5 7.5 0 1 0-7.517 0c.85.493 1.509 1.333 1.509 2.316V18" />
         </svg>
  )
};

